import React, { useRef, useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TopBusinessesRevenueChart = ({ data }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  useEffect(() => {
    const measure = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    };
    measure();
    const ro = new ResizeObserver(measure);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const processedData = data || [];

  let topBusinesses = processedData
    .filter(b => (b.raw_revenue || b.revenue || b.total_revenue || 0) > 0)
    .slice(0, 5)
    .map((b, i) => {
      const name = b.business_name || b.name || 'Unknown';
      const revenue = b.raw_revenue || b.revenue || b.total_revenue || 0;
      return { rank: i + 1, name: name.length > 8 ? name.substring(0, 8) + '…' : name, fullName: name, revenue };
    });

  if (topBusinesses.length === 0) {
    topBusinesses = [
      { rank: 1, name: 'Biz 1', fullName: 'Business 1', revenue: 250000 },
      { rank: 2, name: 'Biz 2', fullName: 'Business 2', revenue: 180000 },
      { rank: 3, name: 'Biz 3', fullName: 'Business 3', revenue: 120000 },
      { rank: 4, name: 'Biz 4', fullName: 'Business 4', revenue: 80000 },
      { rank: 5, name: 'Biz 5', fullName: 'Business 5', revenue: 50000 },
    ];
  }

  const chartH = 200;

  return (
    <div
      className="chart-widget"
      style={{ background: 'white', padding: '16px', borderRadius: '8px', width: '100%', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}
    >
      <h3 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '12px', color: '#1a1a1a', margin: '0 0 12px 0' }}>
        Top 5 Businesses by Revenue
      </h3>
      {/* measure div — no overflow:hidden so width is readable */}
      <div ref={containerRef} style={{ width: '100%' }}>
        {containerWidth > 0 && (
          <LineChart
            width={containerWidth}
            height={chartH}
            data={topBusinesses}
            margin={{ top: 5, right: 10, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="rank" ticks={[1,2,3,4,5]} tick={{ fontSize: 11 }} stroke="#6b7280" />
            <YAxis tick={{ fontSize: 11 }} stroke="#6b7280" tickFormatter={v => `${(v/1000).toFixed(0)}k`} />
            <Tooltip
              formatter={v => [`₹${v.toLocaleString()}`, 'Revenue']}
              labelFormatter={(label, payload) => payload?.[0] ? `Rank ${label}: ${payload[0].payload.fullName}` : `Rank ${label}`}
              contentStyle={{ backgroundColor: 'white', border: '1px solid #e5e7eb', borderRadius: '6px', fontSize: '12px' }}
            />
            <Line type="monotone" dataKey="revenue" stroke="#2563eb" strokeWidth={2} dot={{ fill: '#2563eb', r: 4 }} activeDot={{ r: 6 }} />
          </LineChart>
        )}
      </div>
    </div>
  );
};

export default TopBusinessesRevenueChart;
